import { Colors } from "./colors";

export const SET_COLORS = async ({ CSP }) => {
  if (CSP === "DT") {
    Colors.TopNavigation = "white";
    Colors.headerTintColor = "#50c878";
    Colors.headerRightbackgroundColor = "#50c878";
    Colors.headerRightIconsColor = "#50c878";
    Colors.headerLeftTintColor = "#50c878";
    Colors.sECONDmAJORcOLORfORbUTTONS = "#636e72";
    Colors.cLEARcARTbUTTONcOLOR = "#50c878";
    Colors.ThemeBGcolor = "#50c878";
    Colors.counterButtonColors = "#5b5b5b";
    Colors.ProgressBar = "#50c878";
    Colors.FontColor = "#ffff";
    Colors.LightBG = "#DFFFDE";
    Colors.LightGreyScale = "#E3E3E3";
    Colors.DarkGreyScale = "#474747";
    Colors.GreyScale = "#C0C0C0";
  } else if (CSP === "AV") {
    Colors.TopNavigation = "white";
    Colors.headerTintColor = "#273c75";
    Colors.headerRightbackgroundColor = "#273c75";
    Colors.headerRightIconsColor = "#273c75";
    Colors.headerLeftTintColor = "#273c75";
    Colors.sECONDmAJORcOLORfORbUTTONS = "#636e72";
    Colors.cLEARcARTbUTTONcOLOR = "#273c75";
    Colors.ThemeBGcolor = "#273c75";
    Colors.counterButtonColors = "#273c75";
    Colors.ProgressBar = "#ffc30e";
    Colors.FontColor = "#ffff";
    Colors.LightBG = "#DCDCFF";
    Colors.LightGreyScale = "#E3E3E3";
    Colors.DarkGreyScale = "#474747";
    Colors.GreyScale = "#C0C0C0";
  } else if (CSP === "MK") {
    Colors.TopNavigation = "white";
    Colors.headerTintColor = "#2c8bff";
    Colors.headerRightbackgroundColor = "#2c8bff";
    Colors.headerRightIconsColor = "#2c8bff";
    Colors.headerLeftTintColor = "#2c8bff";
    Colors.sECONDmAJORcOLORfORbUTTONS = "#636e72";
    Colors.cLEARcARTbUTTONcOLOR = "#2c8bff";
    Colors.ThemeBGcolor = "#2c8bff";
    Colors.counterButtonColors = "#2c8bff";
    Colors.ProgressBar = "#2c8bff";
    Colors.FontColor = "#ffff";
    Colors.LightBG = "#DEF9FF";
    Colors.LightGreyScale = "#E3E3E3";
    Colors.DarkGreyScale = "#474747";
    Colors.GreyScale = "#C0C0C0";
  } 
};
